import React, { useState, useEffect } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import {
    InputLabel,
    MenuItem,
    Button,
    Input,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    TextField,
    InputBase,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Radio,
} from '@material-ui/core';

import Select from 'react-select';

import { COLORS } from './Theme';
import { SIcon } from './Icon';
import NumberFormat from 'react-number-format';
import { propTypes } from 'react-bootstrap/esm/Image';
import CompanyList from './CompanyList';

const useStyles = makeStyles((theme) => ({
    title: {
        textAlign: 'center',
        display: 'inline-block',
        alignContent: 'center',
        padding: 0,
        '& h2': {
            color: `${COLORS.WATER_BLUE}`,
            fontFamily: 'NanumB',
            fontSize: '3vh',
            '& svg': {
                margin: 'auto',
                marginRight: '2vw',
            },
        },
    },
    icon: {
        textAlign: 'center',
        paddingBottom: 0,
        [theme.breakpoints.up('md')]: {
            marginBottom: '3vh',
        },
    },
    content: {
        textAlign: 'center',
        marginTop: '4vh',
        marginBottom: '2.5vh',
        overflowY: 'visible',
        padding: 0,
        '& #contentTitle': {
            color: `${COLORS.CHARCOAL_GREY}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            marginBottom: '1vh',
        },
    },
    action: {
        padding: 0,
        '& button': {
            fontSize: '16px',
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },

    underline: {
        // borderBottom: "0px solid red !important",
        '&:hover': {
            borderBottom: '0px solid rgba(0,0,0,0)',
        },
        backgroundColor: '#ffffff',
    },

    desc: {
        fontSize: '2.3vw',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.body1,
        },
    },

    orderComplete: {
        textAlign: 'center',
        marginRight: 3,
        color: `${COLORS.WATER_BLUE}`,
        fontWeight: 'bold',
        fontSize: '5vw',
        [theme.breakpoints.up('md')]: {
            fontSize: '28px',
        },
    },

    buttonText: {
        fontSize: '16px',
    },

    warnText: {
        color: 'red',
        fontWeight: 'bold',
        fontSize: '4vw',
        [theme.breakpoints.up('md')]: {
            fontSize: '30px',
        },
    },
}));

const DialogConfirm: React.FC<any> = (props) => {
    const classes = useStyles();
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'inline-block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '3vh',
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            color: `${COLORS.CHARCOAL_GREY}`,
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="subtitle2"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontWeight: 'bold',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        {props.context}
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                {props.alarm !== true && (
                    <Button onClick={props.noConfirm}>
                        <Typography variant="body1">{props.noText}</Typography>
                    </Button>
                )}
                <Button onClick={props.yesConfirm}>
                    <Typography variant="body1">{props.yesText}</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirm.defaultProps = {
    yesText: '완료',
    noText: '취소',
    alarm: false,
};

const DialogConfirm2: React.FC<any> = (props) => {
    const classes = useStyles();
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'inline-block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '3vh',
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            color: `${COLORS.CHARCOAL_GREY}`,
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="subtitle2"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            whiteSpace: 'pre-line',
                        }}
                    >
                        <span>재료의 </span>
                        <Typography className={classes.warnText}>
                            이름, 크기
                        </Typography>
                        <span>를 확인해주세요.</span>
                        <br />
                        <br />
                        {props.context}
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                <Button onClick={props.yesConfirm}>
                    <Typography variant="body1">{props.noText}</Typography>
                </Button>
                <Button
                    onClick={props.handleMoveReceipt}
                    style={
                        {
                            // width: 'auto',
                            // height: 'auto',
                            // borderRadius: '5px',
                            // backgroundColor: `${COLORS.WATER_BLUE}`,
                            // color: `${COLORS.LIGHT_GREY}`,
                            // padding: '1vw',
                            // fontFamily: 'NanumB',
                            // fontWeight: 'bold',
                        }
                    }
                >
                    <Typography variant="body1">영수증 확인하기</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirm2.defaultProps = {
    yesText: '확인',
    noText: '취소',
    alarm: false,
};

const DialogConfirmDetail: React.FC<any> = (props) => {
    const classes = useStyles();
    const [detail, setDetail] = useState(false);
    const handleDetailButton = () => {
        setDetail((prevState: boolean) => !prevState);
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'inline-block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '3vh',
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            color: `${COLORS.CHARCOAL_GREY}`,
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="subtitle2"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            whiteSpace: 'pre-line',
                        }}
                    >
                        {detail === false ? props.context1 : props.context}
                    </Typography>
                </DialogContentText>
                <Button onClick={handleDetailButton}>
                    <Typography variant="body1">{props.detailText}</Typography>
                </Button>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                {props.alarm !== true && (
                    <Button onClick={props.noConfirm}>
                        <Typography variant="body1">{props.noText}</Typography>
                    </Button>
                )}
                <Button onClick={props.yesConfirm}>
                    <Typography variant="body1">{props.yesText}</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirmDetail.defaultProps = {
    yesText: '완료',
    noText: '취소',
    detailText: '부족한 재료 보기',
    alarm: false,
};

const DialogInputConfirm: React.FC<any> = (props) => {
    const classes = useStyles();
    const [input, setInput] = useState<number | undefined>(props.price);
    const [selectedCompany, setSelectedCompany] = useState<number>(0);

    const handleRadioChange = (event: any) => {
        const selected = props.companyList.find(
            (company: any) =>
                company.company_num.toString() === event.target.value
        );
        console.log('selected? ', selected.company_num);
        setSelectedCompany(selected.company_num);
        //onCompanySelect(selected); // 부모 컴포넌트에 선택된 회사 전달
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value == '' || parseInt(e.target.value) >= 0) {
            setInput(parseInt(e.target.value));
        }
    };

    const confirm = (e: any) => {
        if (input !== undefined && input > 0) {
            props.yesConfirm(input, selectedCompany);
        }
    };

    const handleNo = () => {
        props.noConfirm();
        setSelectedCompany(0);
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleNo}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '1vh',
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            color: `${COLORS.CHARCOAL_GREY}`,
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>
                <DialogContentText
                    style={{
                        height: '15vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        width: '80%',
                        padding: '10px',
                    }}
                >
                    {props.companyList && (
                        <RadioGroup onChange={handleRadioChange}>
                            {props.companyList.map(
                                (item: any, index: number) => (
                                    <FormControlLabel
                                        style={{ color: 'black' }}
                                        key={index}
                                        value={item.company_num.toString()}
                                        control={
                                            <Radio style={{ color: 'black' }} />
                                        }
                                        label={item.company_name}
                                    />
                                )
                            )}
                        </RadioGroup>
                    )}
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="h2"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            //fontSize: '3.5vw',
                            fontWeight: 'bold',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        {props.context}
                    </Typography>
                </DialogContentText>
                <InputBase
                    style={{
                        backgroundColor: `${COLORS.LIGHT_GREY}`,
                        width: '80%',
                        height: '40px',
                        borderRadius: 12,
                        //display: 'flex',
                        fontSize: '16px',
                    }}
                    autoFocus
                    margin="dense"
                    type="number"
                    value={input}
                    onChange={handleChange}
                    inputProps={{
                        'aria-label': 'search google maps',
                        style: { textAlign: 'center' },
                    }}
                />
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                {props.alarm !== true && (
                    <Button className={classes.buttonText} onClick={handleNo}>
                        {props.noText}
                    </Button>
                )}
                <Button className={classes.buttonText} onClick={confirm}>
                    {props.yesText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogInputConfirm.defaultProps = {
    yesText: '완료',
    noText: '취소',
    alarm: false,
};

const DialogCompanyApproval: React.FC<any> = (props) => {
    const classes = useStyles();

    let variant: any;

    if (props.companyType == 'M') {
        variant = [
            { value: 'purchase', label: '구매담당자' },
            { value: 'sale', label: '판매담당자' },
            { value: 'production', label: '생산담당자' },
        ];
    } else if (props.companyType == 'D') {
        variant = [
            { value: 'purchase', label: '구매담당자' },
            { value: 'sale', label: '판매담당자' },
            { value: 'production', label: '분해담당자' },
        ];
    } else if (props.companyType == 'S') {
        variant = [
            { value: 'purchase', label: '구매 및 수익창출담당자' },
            { value: 'production', label: '분해담당자' },
            { value: 'sale', label: '판매담당자' },
        ];
    } else {
        variant = [
            { value: 'purchase', label: '구매담당자' },
            { value: 'sale', label: '판매담당자' },
            { value: 'production', label: '생산담당자' },
        ];
    }

    const [grade, setGrade] = useState(variant[0]);

    const onSelectChange = (e: any) => {
        setGrade(e);
    };

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setGrade(event.target.value as string);
    };

    const handleYes = () => {
        if (grade.label !== '') {
            props.yesConfirm(grade.label);
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 27,
                    boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                    // maxWidth: 400,
                    textAlign: 'center',
                    alignContent: 'center',
                    padding: '5vh 15vw 3vh',
                    overflowY: 'visible',
                    // height: '50vh',
                    // maxHeight: 300,
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.title}>
                <SIcon type={'Profile_Green'} />
                {props.companyName}
                {/* <h5>팀원 추가하기</h5> */}
                {/* <Typography variant="h5" style={{ color: `${COLORS.WATHER_BLUE}` }}>
                    팀원 추가하기
                </Typography> */}
            </DialogTitle>

            <DialogContent className={classes.content}>
                <Typography variant="h1" id="contentTitle">
                    {props.memberName}님의 역할
                </Typography>
                <Select
                    // className={classes.select}s
                    isSearchable={false}
                    value={grade}
                    onChange={onSelectChange}
                    defaultValue={variant[0]}
                    options={variant}
                />
            </DialogContent>
            <DialogActions
                style={{ justifyContent: 'space-around' }}
                className={classes.action}
            >
                <Button onClick={props.noConfirm}>
                    <Typography variant="body1" id="contentTitle">
                        취소
                    </Typography>
                </Button>
                <Button onClick={handleYes}>
                    <Typography variant="body1" id="contentTitle">
                        완료
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogSaleApproval: React.FC<any> = (props) => {
    const classes = useStyles();

    const handleYes = () => {
        props.yesConfirm();
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 27,
                    boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                    // maxWidth: 400,
                    textAlign: 'center',
                    alignContent: 'center',
                    padding: '5vh 15vw 3vh',
                    overflowY: 'visible',
                    // height: '50vh',
                    // maxHeight: 300,
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.title}>재료 판매하기</DialogTitle>

            <DialogContent className={classes.content}>
                <Typography variant="h3" id="contentTitle">
                    기업명: {props.companyName}
                </Typography>
                <div style={{ paddingTop: '2vh' }}></div>
                <Typography variant="h1" id="contentTitle">
                    위 기업에 재료를 판매하시겠습니까?
                </Typography>
            </DialogContent>
            <DialogActions
                style={{ justifyContent: 'space-around' }}
                className={classes.action}
            >
                <Button onClick={props.noConfirm}>
                    <Typography variant="body1" id="contentTitle">
                        취소
                    </Typography>
                </Button>
                <Button onClick={handleYes}>
                    <Typography variant="body1" id="contentTitle">
                        완료
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};
const DialogSaleApprovalPrice: React.FC<any> = (props) => {
    const classes = useStyles();

    const handleYes = () => {
        props.yesConfirm();
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 27,
                    boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                    // maxWidth: 400,
                    textAlign: 'center',
                    alignContent: 'center',
                    padding: '5vh 5vw',
                    overflowY: 'auto',
                    // height: '50vh',
                    // maxHeight: 300,
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.title}>재료 판매하기</DialogTitle>

            <DialogContent className={classes.content}>
                <Typography variant="h3" id="contentTitle">
                    기업명: {props.companyName}
                </Typography>
                <Typography variant="h2" id="contentTitle">
                    총 금액: {props.totalPrice} 원
                </Typography>
                <div style={{ paddingTop: '2vh' }}></div>
                <Typography variant="h1" id="contentTitle">
                    위 기업에 재료를 판매하시겠습니까?
                </Typography>
                <Typography className={classes.desc}>
                    *재료를 제조 기업에게 전달 후 '완료'를 눌러야 합니다.
                </Typography>
            </DialogContent>
            <DialogActions
                style={{ justifyContent: 'space-around' }}
                className={classes.action}
            >
                <Button onClick={props.noConfirm}>
                    <Typography variant="body1" id="contentTitle">
                        취소
                    </Typography>
                </Button>
                <Button onClick={handleYes}>
                    <Typography variant="body1" id="contentTitle">
                        완료
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};
const DialogInput: React.FC<any> = (props) => {
    const classes = useStyles();
    const [input, setInput] = useState<number | undefined>();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value == '' || parseInt(e.target.value) >= 0) {
            setInput(parseInt(e.target.value));
        }
    };

    const confirm = (e: any) => {
        if (input !== undefined && input > 0) {
            props.yesConfirm(e, input);
        }
    };

    useEffect(() => {
        setInput(undefined);
    }, [props.open]);

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                    // maxWidth: 400,
                    paddingLeft: '3vw',
                    paddingRight: '3vw',
                    paddingTop: '3vh',
                    paddingBottom: '3vh',
                    // height: '25vh',
                    // maxHeight: 300,
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    justifyContent: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <DialogContentText
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontFamily: 'NanumB',
                            fontWeight: 'bold',
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <InputBase
                    style={{
                        backgroundColor: `${COLORS.LIGHT_GREY}`,
                        width: '68%',
                        height: '5.4vh',
                        borderRadius: 12,
                        display: 'flex',
                        margin: 'auto',
                    }}
                    autoFocus
                    margin="dense"
                    type="number"
                    value={input}
                    onChange={handleChange}
                    inputProps={{
                        'aria-label': 'search google maps',
                        style: { textAlign: 'center' },
                    }}
                />
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                <Button onClick={props.noConfirm}>
                    <Typography variant="body1">취소</Typography>
                </Button>
                <Button style={{ fontSize: '3vw' }} onClick={confirm}>
                    <Typography variant="body1">완료</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogInputText: React.FC<any> = (props) => {
    const classes = useStyles();
    const [input, setInput] = useState<string | undefined>();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value);
    };

    const confirm = (e: any) => {
        if (input !== undefined) {
            props.yesConfirm(e, input);
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: '37vh',
                    // maxWidth: 400,
                    paddingTop: '3vh',
                    paddingBottom: '3vh',
                    // height: '25vh',
                    // maxHeight: 300,
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    justifyContent: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <DialogContentText
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Typography
                        variant="h4"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontFamily: 'NanumB',
                            fontWeight: 'bold',
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>
                <InputBase
                    style={{
                        backgroundColor: `${COLORS.LIGHT_GREY}`,
                        width: '52vw',
                        height: '5.4vh',
                        borderRadius: 12,
                        display: 'flex',
                        margin: 'auto',
                    }}
                    autoFocus
                    margin="dense"
                    type="text"
                    value={input}
                    onChange={handleChange}
                    inputProps={{
                        'aria-label': 'search google maps',
                        style: { textAlign: 'center' },
                    }}
                />

                {/* <div style={{ width: '100%'}}>
                    <TextField
                        style={{ width: '80%' }}
                        id="standard-number" label="대출금"
                        type="number" name="loan_price"
                        // inputStyle={{ textAlign: 'center' }}
                        // inputProps={{
                        //     style: { textAlign: "right" }
                        // }}
                        value={input} onChange={handleChange} />
                </div> */}
            </DialogContent>

            <DialogActions
                style={{ justifyContent: 'center', fontSize: '3vw' }}
            >
                <Button onClick={props.noConfirm}>취소</Button>
                <Button onClick={confirm}>완료</Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogInputText2: React.FC<any> = (props) => {
    const [input, setInput] = useState<string | undefined>();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value);
    };

    const confirm = (e: any) => {
        if (input !== undefined) {
            props.yesConfirm(e, input);
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: '40vh',
                    // maxWidth: 400,
                    paddingTop: '3vh',
                    paddingBottom: '3vh',
                    // height: '25vh',
                    // maxHeight: 300,
                },
            }}
            translate="no"
        >
            <DialogContent
                style={{
                    justifyContent: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <DialogContentText>
                    <Typography
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontFamily: 'NanumB',
                            fontWeight: 'bold',
                            fontSize: '16px',
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>
                <InputBase
                    style={{
                        backgroundColor: `${COLORS.LIGHT_GREY}`,
                        width: '80%',
                        height: '40px',
                        borderRadius: 12,
                        display: 'flex',
                        fontSize: '16px',
                    }}
                    autoFocus
                    margin="dense"
                    type="text"
                    value={input}
                    onChange={handleChange}
                    inputProps={{
                        'aria-label': 'search google maps',
                        style: { textAlign: 'center' },
                    }}
                />

                {/* <div style={{ width: '100%'}}>
                    <TextField
                        style={{ width: '80%' }}
                        id="standard-number" label="대출금"
                        type="number" name="loan_price"
                        // inputStyle={{ textAlign: 'center' }}
                        // inputProps={{
                        //     style: { textAlign: "right" }
                        // }}
                        value={input} onChange={handleChange} />
                </div> */}
            </DialogContent>

            <DialogActions
                style={{ justifyContent: 'center', fontSize: '18px' }}
            >
                <Button onClick={props.noConfirm}>취소</Button>
                <Button onClick={confirm}>완료</Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogDeleteClass: React.FC<any> = (props) => {
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '40vw',
                    height: '20vw',
                },
            }}
            translate="no"
        >
            <DialogContent
                style={{
                    display: 'inline-block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    padding: '17% 0 0 0',
                }}
            >
                <DialogContentText
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            marginBottom: '2vh',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontSize: '1.8vw',
                            fontWeight: 'bold',
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="h2"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontSize: '1.8vw',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        {props.context}
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions
                style={{
                    justifyContent: 'center',
                    padding: '3%',
                    marginBottom: '3vh',
                }}
            >
                {props.alarm !== true && (
                    <Button
                        style={{ fontSize: '1.8vw' }}
                        onClick={props.noConfirm}
                    >
                        취소
                    </Button>
                )}
                <Button
                    style={{ color: 'Red', fontSize: '1.8vw' }}
                    onClick={props.yesConfirm}
                >
                    삭제
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogApprove: React.FC<any> = (props) => {
    const classes = useStyles();
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon
                    type={'Dialog'}
                    style={{
                        textAlign: 'center',
                        width: '5vw',
                        height: 'auto',
                    }}
                />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'inline-block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '3vh',
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontSize: '2.5vw',
                            fontWeight: 'bold',
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="h2"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontSize: '2vw',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        {props.context}
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                {props.alarm !== true && (
                    <Button
                        style={{ fontSize: '2vw' }}
                        onClick={props.noConfirm}
                    >
                        취소
                    </Button>
                )}
                <Button style={{ fontSize: '2vw' }} onClick={props.yesConfirm}>
                    승인
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogPopup: React.FC<any> = (props) => {
    const classes = useStyles();
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 40,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: '30vh',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'inline-block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '3vh',
                        marginTop: '2vh',
                    }}
                >
                    <Typography variant="h1" className={classes.orderComplete}>
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontWeight: 'bold',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        {props.context}
                    </Typography>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

const DialogDeleteCompany: React.FC<any> = (props) => {
    const classes = useStyles();
    console.log('props context? ', props.context);
    const members = props.context;
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon
                    type={'Dialog'}
                    style={{
                        textAlign: 'center',
                        width: '5vw',
                        height: 'auto',
                    }}
                />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'inline-block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '3vh',
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            color: `${COLORS.CHARCOAL_GREY}`,
                            fontSize: '4.5vw',
                            fontWeight: 'bold',
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText>
                    <Typography
                        variant="h2"
                        style={{
                            textAlign: 'center',
                            color: COLORS.CHARCOAL_GREY,
                            fontSize: '3vw',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        이 기업에는
                    </Typography>
                    <br />
                    {members &&
                        members.map((member: any, index: number) => (
                            <Typography
                                key={index}
                                variant="h2"
                                style={{
                                    textAlign: 'center',
                                    color: COLORS.CHARCOAL_GREY,
                                    fontSize: '4vw',
                                    whiteSpace: 'pre-line',
                                }}
                            >
                                이름: {member.member_name}
                            </Typography>
                        ))}
                    <br />
                    <Typography
                        variant="h2"
                        style={{
                            textAlign: 'center',
                            color: COLORS.CHARCOAL_GREY,
                            fontSize: '3vw',
                            whiteSpace: 'pre-line',
                        }}
                    >
                        총 {members ? members.length : 0}명이 있습니다.
                    </Typography>
                    <br />
                    <Typography
                        variant="h2"
                        style={{
                            textAlign: 'center',
                            color: 'red',
                            fontSize: '3vw',
                            fontWeight: 'bold',
                        }}
                    >
                        삭제 후에는 복구할 수 없습니다.
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                {props.alarm !== true && (
                    <Button
                        style={{ fontSize: '4vw' }}
                        onClick={props.noConfirm}
                    >
                        취소
                    </Button>
                )}
                <Button style={{ fontSize: '4vw' }} onClick={props.yesConfirm}>
                    승인
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogSelectCompany: React.FC<any> = (props) => {
    const classes = useStyles();
    const [selectedCompany, setSelectedCompany] = useState<number>(0);

    const handleRadioChange = (event: any) => {
        const selected = props.companyList.find(
            (company: any) =>
                company.company_num.toString() === event.target.value
        );
        console.log('selected? ', selected.company_num);
        setSelectedCompany(selected.company_num);
        //onCompanySelect(selected); // 부모 컴포넌트에 선택된 회사 전달
    };

    const handleYes = () => {
        props.yesConfirm(selectedCompany);
    };

    const handleNo = () => {
        props.noConfirm();
        setSelectedCompany(0);
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleNo}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    backgroundColor: `${COLORS.WHITE}`,
                    width: '84vw',
                    height: 'auto',
                },
            }}
            translate="no"
        >
            <DialogTitle className={classes.icon}>
                <SIcon type={'Dialog'} />
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    paddingTop: 0,
                }}
            >
                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '3vh',
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            textAlign: 'center',
                            marginRight: 3,
                            color: `${COLORS.CHARCOAL_GREY}`,
                        }}
                    >
                        {props.title}
                    </Typography>
                </DialogContentText>

                <DialogContentText
                    style={{
                        height: '15vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        width: '80%',
                        padding: '10px',
                    }}
                >
                    {props.companyList && (
                        <RadioGroup onChange={handleRadioChange}>
                            {props.companyList.map(
                                (item: any, index: number) => (
                                    <FormControlLabel
                                        style={{ color: 'black' }}
                                        key={index}
                                        value={item.company_num.toString()}
                                        control={
                                            <Radio style={{ color: 'black' }} />
                                        }
                                        label={item.company_name}
                                    />
                                )
                            )}
                        </RadioGroup>
                    )}
                </DialogContentText>

                <DialogContentText
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '3vh',
                        marginBottom: '0px',
                    }}
                >
                    <Typography
                        variant="h2"
                        style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            color: 'black',
                        }}
                    >
                        {props.context}
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                {props.alarm !== true && (
                    <Button style={{ fontSize: '16px' }} onClick={handleNo}>
                        취소
                    </Button>
                )}
                <Button style={{ fontSize: '16px' }} onClick={handleYes}>
                    확인
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogConfirm;
export {
    DialogConfirm,
    DialogConfirm2,
    DialogConfirmDetail,
    DialogInputConfirm,
    DialogCompanyApproval,
    DialogSaleApproval,
    DialogInput,
    DialogInputText,
    DialogDeleteClass,
    DialogApprove,
    DialogSaleApprovalPrice,
    DialogPopup,
    DialogInputText2,
    DialogDeleteCompany,
    DialogSelectCompany,
};
